import { AggregateLevel } from "./AggregateLevel";

export const aggregateLevels: AggregateLevel[] = [
  "year",
  "month",
  "week",
  "day",
  "hour",
  "minute",
];
